import { Badge } from "@/components/ui/badge"
import { Loader2 } from "lucide-react"

const statusConfig = {
  draft: { label: "Draft", className: "bg-zinc-100 text-zinc-600" },
  generating_script: {
    label: "Generating Script",
    className: "bg-amber-100 text-amber-800",
    animated: true,
  },
  script_generated: {
    label: "Script Ready",
    className: "bg-blue-100 text-blue-800",
  },
  rendering: {
    label: "Rendering Audio",
    className: "bg-amber-100 text-amber-800",
    animated: true,
  },
  uploading: {
    label: "Uploading",
    className: "bg-amber-100 text-amber-800",
    animated: true,
  },
  uploaded: {
    label: "Ready to Publish",
    className: "bg-emerald-100 text-emerald-800",
  },
  published: {
    label: "Published",
    className: "bg-green-100 text-green-800",
  },
  failed: {
    label: "Failed",
    className: "bg-red-100 text-red-800",
  },
}

export function PodcastStatusBadge({ status }) {
  if (!status) return null

  const config = statusConfig[status]
  if (!config) return null

  return (
    <Badge variant="outline" className={`border-0 ${config.className}`}>
      {config.animated && (
        <Loader2 className="h-3 w-3 animate-spin mr-1" />
      )}
      {config.label}
    </Badge>
  )
}
